<template>
    <div class="waba-supsis-message-template-components-update">
        <div class="title">Whatsapp Business API V2 mesaj şablonu bileşenleri güncellendi</div>
        <div class="meta">
            <div><b>Event</b>: {{ $_.get(activity, "payload.event") }}</div>
            <div><b>Kanal ID</b>: {{ $_.get(activity, "payload.channelId") }}</div>
            <div><b>Şablon Adı</b>: {{ $_.get(activity, "payload.message_template_name") }}</div>
            <div><b>Şablon ID</b>: {{ $_.get(activity, "payload.message_template_id") }}</div>
            <div><b>Dil</b>: {{ $_.get(activity, "payload.message_template_language") }}</div>
            <div v-if="$_.get(activity, 'payload.message_template_title')">
                <b>Başlık</b>: {{ $_.get(activity, "payload.message_template_title") }}
            </div>
            <div v-if="$_.get(activity, 'payload.message_template_element')">
                <b>İçerik</b>: {{ $_.get(activity, "payload.message_template_element") }}
            </div>
            <div v-if="$_.get(activity, 'payload.message_template_footer')">
                <b>Footer</b>: {{ $_.get(activity, "payload.message_template_footer") }}
            </div>
            <div v-if="templateButtons.length > 0">
                <b>Butonlar</b>:
                <ul class="buttons-list">
                    <li v-for="(btn, idx) in templateButtons" :key="idx">
                        {{ btn.message_template_button_text }} ({{ btn.message_template_button_type }})
                    </li>
                </ul>
            </div>
        </div>
        <details class="raw">
            <summary>Ham payload</summary>
            <pre>{{ prettyPayload }}</pre>
        </details>
    </div>
</template>
<script>
import Vue from "vue";

export default Vue.extend({
    name: "WabaSupsisMessageTemplateComponentsUpdate",
    props: {
        activity: {
            type: Object,
            default: () => ({}),
        },
    },
    computed: {
        prettyPayload() {
            try {
                return JSON.stringify(this.$_.get(this.activity, "payload", {}), null, 2);
            } catch (e) {
                return String(this.$_.get(this.activity, "payload", ""));
            }
        },
        templateButtons() {
            return this.$_.get(this.activity, "payload.message_template_buttons", []);
        },
    },
});
</script>

<style scoped lang="scss">
.waba-supsis-message-template-components-update {
    .title {
        font-weight: 600;
        margin-bottom: 6px;
    }
    .meta {
        display: flex;
        flex-direction: column;
        gap: 2px;
        margin-bottom: 8px;
    }
    .buttons-list {
        margin: 4px 0 0 16px;
        padding: 0;
        li {
            margin: 2px 0;
        }
    }
    .raw {
        pre {
            max-height: 240px;
            overflow: auto;
            padding: 10px;
            border: 1px solid var(--color-border-default);
            border-radius: 6px;
            background: var(--color-bg-neutral-default);
        }
        summary {
            cursor: pointer;
            user-select: none;
            margin-bottom: 6px;
        }
    }
}
</style>
